import {
  Modal,
  Box,
  InputLabel,
  Select,
  MenuItem,
  Button,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Typography,
  Snackbar,
  Alert,
} from "@mui/material";

import { useEffect, useMemo, useState } from "react";
import axios from "axios";
import addIcon from "../../assets/icons/addItemIcon.svg";
import closeIcon from "../../assets/icons/closeIcon.svg";

const CreateNewReleaseModal = () => {
  const [open, setOpen] = useState(false);
  const [alertOpen, setAlertOpen] = useState(false);
  const [clients, setClients] = useState<any>([]);
  const [selectedClient, setSelectedClient] = useState<any>({});
  const [selectedDestinationClient, setSelectedDestinationClient] =
    useState<any>({});
  const [selectedSource, setSelectedSource] = useState<any>({});
  const [selectedDestination, setSelectedDestination] = useState<any>({});
  const [envDefinitions, setEnvDefinitions] = useState<any>([]);
  const [destinationEnvDefinitions, setDestinationEnvDefinitions] =
    useState<any>([]);
  const [sourceResources, setSourceResources] = useState<any>([]);
  const [destinationResources, setDestinationResources] = useState<any>([]);
  const [resourceTypes, setResourceTypes] = useState<any>([]);
  const [builds, setBuilds] = useState<any>({});
  const [selectedBuildVersion, setSelectedBuildVersion] = useState<any>({});
  const [selectedType, setSelectedType] = useState('')


  const sourceColumns = useMemo(
    () => [
      { header: "Name", key: "BuildPipeline_Nm" },
      { header: "Type", key: "Resource_Typ" },
    ],
    []
  );
  const destinationColumns = useMemo(
    () => [
      { header: "Name", key: "ReleasePipeline_Nm" },
      { header: "Type", key: "Resource_Typ" },
    ],
    []
  );

  const handleSelectChange = async (value: any) => {
    console.log(value);
    setSelectedClient(value);
    if (value?.Client_Nm) {
      await axios
        .get(
          `https://p360zingadmin-t4-devenvapi.azurewebsites.net/api/client/getEnvbyClient/?Client_Id=${value.Id}`
        )
        .then(({ data }) => {
          setEnvDefinitions(data);
        })
        .catch((err) => {
          console.error(err);
        });
    }
  };
  const handleDestinationClientChange = async (value: any) => {
    setSelectedDestinationClient(value);
    if (value?.Client_Nm) {
      await axios
        .get(
          `https://p360zingadmin-t4-devenvapi.azurewebsites.net/api/client/getEnvbyClient/?Client_Id=${value.Id}`
        )
        .then(({ data }) => {
          setDestinationEnvDefinitions(data);
        })
        .catch((err) => {
          console.error(err);
        });
    }
  };
  const handleSourceChange = async (value: any) => {
    setSelectedSource(value);
    if (value.Env_Nm) {
      await axios
        .get(
          `https://p360zingadmin-t4-devenvapi.azurewebsites.net/api/client/getResourcebyEnvId?Environment_Id=${value.Id}`
        )
        .then(({ data }) => {
          setSourceResources(data);
        })
        .catch((err) => {
          console.error(err);
        });
    }
  };
  const handleDestinationChange = async (value: any) => {
    setSelectedDestination(value);
    if (value.Env_Nm) {
      await axios
        .get(
          `https://p360zingadmin-t4-devenvapi.azurewebsites.net/api/client/getResourcebyEnvId?Environment_Id=${value.Id}`
        )
        .then(({ data }) => {
          console.log("destination resources...........", data);
          setDestinationResources(data);
          const uniqueResourceTypes = data.reduce((acc: any, item: any) => {
            if (!acc.includes(item.Resource_Typ)) {
              acc.push(item.Resource_Typ);
            }
            return acc;
          }, []);
          setResourceTypes(uniqueResourceTypes)
        })
        .catch((err) => {
          console.error(err);
        });
    }
  };
const handleResourceChange = async(type: any) => {
  setSelectedType(type)
  const selectedBuildId = destinationResources.find((x: any) => x.Resource_Typ === type).BuildPipeline_Id;
  console.log(selectedBuildId)
  await axios
  .get(
    `https://p360zingadmin-t4-devenvapi.azurewebsites.net/api/builds/getBuildsList?definitionId=${selectedBuildId}`
  )
  .then(({ data }) => {
    setBuilds(data);
  })
  .catch((err) => {
    console.error(err);
  });

}

const handleBuildVersionChange = (value: any) => {
  setSelectedBuildVersion(value);
};
const handleSubmit = async () => {
  // alert(`${selectedBuildVersion.id}, ${selectedRelease.id}`)
  // await
  const definitionId = destinationResources.find((x: any) => x.Resource_Typ === selectedType).ReleasePipeline_Id;
  const buildName = destinationResources.find((x: any) => x.Resource_Typ === selectedType).BuildPipeline_Nm;
  const body = {
    definitionId,
    artifacts: [
      {
        alias: `_${buildName}`,
        instanceReference: {
          id: selectedBuildVersion.id,
          name: null,
        },
      },
    ],
  };
  await axios
    .post("https://p360zingadmin-t4-devenvapi.azurewebsites.net/api/releases/create", body)
    .then(({ data }) => {
      setAlertOpen(true);
    })
    .catch((err) => {
      console.error(err);
    });
};

  useEffect(() => {
    const abort1 = new AbortController();
    const abort2 = new AbortController();
    const abort3 = new AbortController();
    const fetchOptions = async () => {
      if (!selectedClient?.Client_Nm) {
        await axios
          .get(
            `https://p360zingadmin-t4-devenvapi.azurewebsites.net/api/client/allclients`,
            { signal: abort1.signal }
          )
          .then((result) => {
            setClients(result.data);
          })
          .catch((err) => {
            console.error(err);
          });
      }
    };

    fetchOptions();

    return () => {
      abort1.abort();
      abort2.abort();
      abort3.abort();
    };
  }, []);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleCloseAlert = () => setAlertOpen(false);

  return (
    <>
      <Snackbar
        open={alertOpen}
        autoHideDuration={3000}
        onClose={handleCloseAlert}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert onClose={handleCloseAlert} severity="success" sx={{ width: "100%" }}>
          Success! Release triggered successfully.
        </Alert>
      </Snackbar>
      {/* <div
        className="add-btn-section header-icon"
        onClick={() => {
          handleOpen();
          // setModaltitle("Add");
          // setUpdateItemData(false)
          // setUpdateModalFlag(false);
          // setOpenAddItemModal(true)
        }}
      >
        <img src={addIcon} className="icon-md" alt="" />
      </div> */}
       <div
        className="add-btn-section header-icon"
        style={{padding: '0.4rem', color: 'white', background: '#734bd0', borderRadius: '30px'}}
        onClick={() => {
          handleOpen();
          // setModaltitle("Add");
          // setUpdateItemData(false)
          // setUpdateModalFlag(false);
          // setOpenAddItemModal(true)
        }}
      >
        {/* <img src={addIcon} className="icon-md" alt="" /> */}
        Single Release
      </div>
      <Modal open={open} onClose={handleClose}>
        <Box
          className="modal-1-box"
          sx={{ minHeight: "40vh", maxHeight: '60vh' , overflowY: "scroll" }}
        >
          <div className="modal-1-header">
            <div className="modal-1-title">Create Single Release</div>
            <div
              className="modal-1-close-btn-section"
              onClick={() => {
                handleClose();
              }}
            >
              <img src={closeIcon} className="icon-md" alt="" />
            </div>
          </div>
          {/* <Typography variant="h5" fontWeight={600}>
            Select Source
          </Typography> */}
          <div
            style={{
              gridTemplateColumns: "repeat(2, minmax(0, 1fr));",
              display: "grid",
            }}
          >
            {/* <div className="input-div modal-1-input-div">
              <InputLabel id="release-label" className="floating-label">
                Souce Environment
              </InputLabel>
              <Select
                labelId="release-label"
                id="release"
                // value={{}}
                onChange={(e) => handleSelectChange(e.target.value)}
                className="input-field-1 env-multiselect"
              >
                {clients?.map((name: any, index: number) => (
                  <MenuItem value={name} key={index}>
                    {name?.Client_Nm}
                  </MenuItem>
                ))}
              </Select>
            </div>
            <div className="input-div modal-1-input-div">
              <InputLabel id="build-label" className="floating-label">
                Source
              </InputLabel>
              <Select
                labelId="build-label"
                id="build"
                className="input-field-1 env-multiselect"
                onChange={(e) => handleSourceChange(e.target.value)}
              >
                {envDefinitions?.map((name: any, index: any) => (
                  <MenuItem value={name} key={index}>
                    {name?.Env_Nm}
                  </MenuItem>
                ))}
              </Select>
            </div> */}
            <Typography variant="h5" fontWeight={600}>
              Select Destination
            </Typography>
            <div className="input-div modal-1-input-div">
              <InputLabel id="release-label" className="floating-label">
                Client Name
              </InputLabel>
              <Select
                labelId="release-label"
                id="release"
                // value={{}}
                onChange={(e) => handleDestinationClientChange(e.target.value)}
                className="input-field-1 env-multiselect"
              >
                {clients?.map((name: any, index: number) => (
                  <MenuItem value={name} key={index}>
                    {name?.Client_Nm}
                  </MenuItem>
                ))}
              </Select>
            </div>

            <div className="input-div modal-1-input-div">
              <InputLabel id="artifact-label" className="floating-label">
                Environment
              </InputLabel>
              <Select
                labelId="artifact-label"
                id="artifact"
                className="input-field-1 env-multiselect"
                onChange={(e) => handleDestinationChange(e.target.value)}
              >
                {destinationEnvDefinitions?.map((name: any, index: any) => (
                  <MenuItem value={name} key={index}>
                    {name?.Env_Nm}
                  </MenuItem>
                ))}
              </Select>
            </div>
            <div className="input-div modal-1-input-div">
              <InputLabel id="artifact-label" className="floating-label">
                Resource Type
              </InputLabel>
              <Select
                labelId="artifact-label"
                id="artifact"
                className="input-field-1 env-multiselect"
                onChange={(e) => handleResourceChange(e.target.value)}
              >
                {resourceTypes?.map((name: any, index: any) => (
                  <MenuItem value={name} key={index}>
                    {name}
                  </MenuItem>
                ))}
              </Select>
            </div>
            <div className="input-div modal-1-input-div">
              <InputLabel id="artifact-label" className="floating-label">
                Build Version
              </InputLabel>
              <Select
                labelId="artifact-label"
                id="artifact"
                className="input-field-1 env-multiselect"
                onChange={(e) => handleBuildVersionChange(e.target.value)}
              >
                {/* <SelectLabel>Builds</SelectLabel> */}
                {builds?.value?.map((name: any, index: any) => {
                  const formattedTime = new Date(
                    name?.finishTime
                  ).toLocaleString("en-US", {
                    weekday: "long", // 'short', 'long', etc.
                    year: "numeric",
                    month: "long", // '2-digit', 'numeric'
                    day: "numeric",
                    hour: "2-digit", // 'numeric', '2-digit'
                    minute: "2-digit", // 'numeric', '2-digit'
                    second: "2-digit", // 'numeric', '2-digit'
                    hour12: true, // true for 12-hour clock, false for 24-hour clock
                  });
                  let displayText = name?.id + " " + formattedTime;
                  return (
                    <MenuItem value={name} key={index}>
                      {displayText}
                    </MenuItem>
                  );
                })}
              </Select>
            </div>
          </div>
          <button
            onClick={handleSubmit}
            className="rounded-primary-40 btn font--btn export-flow-btn config-save-btn"
          >
            Create
          </button>
        </Box>
      </Modal>
    </>
  );
};

export default CreateNewReleaseModal;
